import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { blockConfig, ItemTypes } from '../../../config';
import itemTypes from '../../../config/itemTypes';

const DragPreviewWrapper = styled.div`
  height: ${p => p.small ? blockConfig.smallHeight : blockConfig.height}px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0px 3px 5px 0px rgba(207, 207, 207, 1);
  position: relative;
  width: 150px;
`;

const PreviewContent = styled.div`
  position: absolute;
  margin-left: 5px;
  bottom: 3px;
  font-size: 13px;
  font-weight: bold;

  span {
    background: #3c85c9;
    color: #fff;
    border-radius: 4px;
    padding: 0px 2px;
  }

  i {
    margin-left: 5px;
    color: rgb(171, 171, 171);
  }
`;

const NoDrop = styled.div`
  position: absolute;
  color: rgb(171, 171, 171);
  bottom: 0px;
  font-size: 15px;
`;

const BlockDragPreview = ({ caption, type, selectedIds }) => {
  let multipleOrdersView = null;
  if ((type === ItemTypes.ORDER || type === ItemTypes.PLANNING) &&
    selectedIds &&
    selectedIds.length > 1
  ) {
    multipleOrdersView = <i className={'fas fa-layer-group'}>{selectedIds.length}</i>;
  }

  let timeView = <NoDrop className={'fas fa-ban'} />;
  if (caption) {
    timeView =
      <>
        <span>{caption}</span>
        {multipleOrdersView}
      </>;
  }

  return (
    <DragPreviewWrapper small={type === itemTypes.NON_PLANNING_BLOCK}>
      <PreviewContent>{timeView}</PreviewContent>
    </DragPreviewWrapper>
  );
};

BlockDragPreview.propTypes = {
  caption: PropTypes.string,
  type: PropTypes.string,
  selectedIds: PropTypes.array,
};

export default BlockDragPreview;
